import React, { useState, useEffect } from 'react';
import './Typing.css';

function Typing({ texts, typingSpeed = 100, deletingSpeed = 50, delayBetween = 2000 }) {
    const [displayText, setDisplayText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        const currentText = texts[currentIndex];
        let timeout;

        if (!isDeleting && displayText === currentText) {
            timeout = setTimeout(() => setIsDeleting(true), delayBetween);
        } else if (isDeleting && displayText === '') {
            setIsDeleting(false);
            setCurrentIndex((prev) => (prev + 1) % texts.length);
        } else {
            const speed = isDeleting ? deletingSpeed : typingSpeed;
            timeout = setTimeout(() => {
                setDisplayText(
                    isDeleting
                        ? currentText.substring(0, displayText.length - 1)
                        : currentText.substring(0, displayText.length + 1)
                );
            }, speed);
        }

        return () => clearTimeout(timeout);
    }, [displayText, isDeleting, currentIndex, texts, typingSpeed, deletingSpeed, delayBetween]);

    return (
        <span className="typing-text">
            {displayText}
            <span className="typing-cursor">|</span>
        </span>
    );
}

export default Typing;


